export default __webpack_public_path__ + "assets/fonts/229b14375e684fb629e680bdd7b5be76.ttf";